import { Skeleton } from '@/components/ui/Skeleton.tsx';
import {
  InfoCard,
  InfoCardBody,
  InfoCardHeader,
  InfoCardRow,
} from '@/components/ui/InfoCard.tsx';

interface DraftImpactCardSkeletonProps
  extends React.HTMLAttributes<HTMLDivElement> {
  /** Ile wierszy „osoba / kwota” odwzorować. */
  entryCount?: number;
}

/** Szkielet karty „Wpływ paczki”: duża kwota, lista osób, wiersz podsumowania. */
const DraftImpactCardSkeleton = ({
  entryCount = 2,
  ...props
}: DraftImpactCardSkeletonProps) => (
  <InfoCard {...props}>
    <InfoCardHeader title={<Skeleton className="h-3.5 w-28" />} />

    <InfoCardBody>
      <Skeleton className="h-7 w-36" />
      {Array.from({ length: entryCount }).map((_, index) => (
        <InfoCardRow key={index} label={<Skeleton className="h-4 w-28" />}>
          <Skeleton className="h-4 w-20" />
        </InfoCardRow>
      ))}
      <InfoCardRow divided label={<Skeleton className="h-4 w-40" />}>
        <Skeleton className="h-4 w-24" />
      </InfoCardRow>
    </InfoCardBody>
  </InfoCard>
);

export default DraftImpactCardSkeleton;
